import {Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, ViewEncapsulation} from "@angular/core";
import {Subject} from "rxjs";
import {AppLayoutService} from "@core/services/app-layout.service";
import {AppService} from "@core/services/app.service";
import {NavService} from "@core/services/nav.service";
import {NavigationEnd, Router, RouterModule} from "@angular/router";
import { INavMenu, navItems} from "@layouts/components";
import {filter} from "rxjs/operators";
import {checkClickDuplicateMenu} from "@layouts/components/nav.util";
import {SCREEN_MAX_MOBILE, UI_CONSTS, uriConsts} from "@shared/constants";
import {ImgCdnPipe} from "@shared/pipes/global";
import { isPlatformBrowser } from "@angular/common";
import {TranslocoModule} from "@jsverse/transloco";


@Component({
  selector: 'app-nav-vertical',
  templateUrl: './nav-vertical.component.html',
  styleUrls: ['./nav-vertical.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    RouterModule,
    TranslocoModule,
    ImgCdnPipe,
  ]
})
export class NavVerticalComponent implements OnInit, OnDestroy {
  readonly uriConsts = uriConsts;
  @Input() isHideCollapseMenu = false;

  private destroyed$ = new Subject();

  navItems: INavMenu[] = navItems;
  previousUrl: string = this.getPathName();
  currentUrl: string = this.getPathName();
  isLoader = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    public app: AppService,
    public appLayout: AppLayoutService,
    private router: Router,
    private navService : NavService,
  ) {
    this.macthNav();
  }

  ngOnInit() {
    this.navService.navItemsAllows$.subscribe(items => {
      this.navItems = items;
      // Sử dụng setTimeout để tránh lỗi ExpressionChangedAfterItHasBeenCheckedError
      setTimeout(() => {
        this.macthNav();
      });
    });
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe({
        next: () => {
          this.previousUrl = this.currentUrl;
          this.currentUrl = this.getPathName();
          if (this.previousUrl != this.currentUrl) {
            this.isLoader = true;
            this.macthNav();
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(null);
    this.destroyed$.complete();
  }

  getPathName() {
    if (isPlatformBrowser(this.platformId)) {
      return window.location.pathname
    }
    return '';
  }

  macthNav() {
    this.navItems.map(gr => {
      gr.children?.map(navs => {
        if (navs.url == this.currentUrl) {
          navs.active = true;
        } else if (navs.children) {
          navs.active = this.macthChild(navs.children);
        } else {
          navs.active = false;
        }
      })
    })
  }

  macthChild(children: INavMenu[]) {
    let isCheck = false;
    children.map(navs => {
      if (navs.url == this.currentUrl) {
        isCheck = true;
        navs.active = true;
      } else if (navs.children) {
        const ckChild = this.macthChild(navs.children);
        navs.active = ckChild;
        if (ckChild) {
          isCheck = true;
        }
      } else {
        navs.active = false;
      }
    })
    return isCheck;
  }


  onHandleClick(url?: string) {
    if (url) {
      checkClickDuplicateMenu(url, this.app)
    }

    if (this.appLayout.screenWidth && this.appLayout.screenWidth < SCREEN_MAX_MOBILE) {
      this.appLayout.isOpenNavMobile = false;
    }
  }


}
